export default __webpack_public_path__ + "static/media/nofication.be0876ee.svg";